<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:right_view>
      <PmTaskManagementToolBarForGnb :enableStatus="enableStatus" ref="pmTaskManagementToolBarForGnb"></PmTaskManagementToolBarForGnb>
      <PmTaskManagementListForGnb @enableStatusChange="enableStatusChange" ref="pmTaskManagementListForGnb"></PmTaskManagementListForGnb>

      <!-- 新增任务弹出框 -->
      <CustomDialog ref='addGnbTaskDialog' :element='addGnbTaskDialog.element' :styles='addGnbTaskDialog.style'>
        <template v-slot:dialog-content>
          <AddGnbTaskDialog ref='addGnbTask'></AddGnbTaskDialog>
        </template>
      </CustomDialog>

      <!-- 补采任务弹出框 -->
      <CustomDialog ref='uploadGnbTaskDialog' :element='uploadGnbTaskDialog.element' :styles='uploadGnbTaskDialog.style'>
        <template v-slot:dialog-content>
          <UploadGnbTaskDialog ref='uploadGnbTask'></UploadGnbTaskDialog>
        </template>
      </CustomDialog>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from '../../../layouts/BasicLayout';
import PmTaskManagementToolBarForGnb from "../../../components/pmConfig/gnb/PmTaskManagementForGnb/PmTaskManagementToolBarForGnb";
import PmTaskManagementListForGnb from "../../../components/pmConfig/gnb/PmTaskManagementForGnb/PmTaskManagementListForGnb";
import CustomDialog from "../../../components/common/CustomDialog";
import AddGnbTaskDialog from "../../../components/pmConfig/gnb/PmTaskManagementForGnb/dialog/AddGnbTaskDialog";
import UploadGnbTaskDialog from "../../../components/pmConfig/gnb/PmTaskManagementForGnb/dialog/UploadGnbTaskDialog";
import {EventBus} from "../../../plugins/eventBus";
import DateUtil from "../../../components/pmConfig/util/DateUtil";

export default {
  name: 'PmTaskManagementForGnb',
  components: {
    BasicLayout,
    PmTaskManagementToolBarForGnb,
    PmTaskManagementListForGnb,
    CustomDialog,
    AddGnbTaskDialog,
    UploadGnbTaskDialog,
    DateUtil
  },
  data() {
    return {
      left: {
        show: false,
        name: ''
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: `${this.$t('Pm.pmManagement')}/${this.$t('Pm.gnbManagement')}/${this.$t('Pm.pmTaskManagement')}`
      },
      uploadGnbTaskDialog: {
        style: {
          width: '600px',
          height: '400px',
          visible: false,
          model: true
        },
        element: {
          title: this.$t('Pm.dataMining'),
          target: this.$refs.pmTaskManagementListForGnb,
          refName: 'uploadGnbTaskElement',
          buttonGroup: [
            { click: this.closeUploadGnbTaskDialog, buttonModel: { content: this.$t('Common.cancel') } },
            { click: this.uploadGnbTaskCommit, buttonModel: { content: this.$t('Pm.finish'), isPrimary: true } }
          ],
          isClose: true
        }
      },

      enableStatus: "2",

      addGnbTaskDialog: {
        style: {
          width: '600px',
          height: '500px',
          visible: false,
          model: true
        },
        element: {
          title: this.$t('Pm.createPmTask'),
          target: this.$refs.pmTaskManagementListForGnb,
          refName: 'addGnbTaskElement',
          buttonGroup: [
            { click: this.closeAddGnbTaskDialog, buttonModel: { content: this.$t('Common.cancel') } },
            { click: this.addGnbTaskCommit, buttonModel: { content: this.$t('Pm.finish'), isPrimary: true } }
          ],
          isClose: true
        }
      },

      gnbUploadGridClickData: {}
    };
  },
  methods: {

    enableStatusChange(msg) {
      this.enableStatus = msg;
    },
    methodList(operator) {
      switch (operator) {
        case 'add':
          this.addTask();
          break;
        case 'enable':
          this.setTaskCommit("1");
          break;
        case 'disable':
          this.setTaskCommit("0");
          break;
        case 'delete':
          this.deleteTaskCommit();
          break;
        case 'upload':
          this.uploadTask();
          break;
        default:
      }
    },

    addTask(){
      this.$refs.addGnbTask.$refs.pmGnbTopoTreeRef.getPmGnbTopoTree();
      this.$refs.addGnbTask.bindValidateOfAddGnbTaskDialog();
      this.$refs.addGnbTaskDialog.show();
    },

    uploadTask(){
      const data = this.$refs.pmTaskManagementListForGnb.rowDataOfPmGnbTaskList;
      if (data == null || data == '') {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectDataPlease') });
        return;
      }
      this.gnbUploadGridClickData = data;
      this.$refs.uploadGnbTaskDialog.show();
    },

    async addGnbTaskCommit() {
      const ruleDatas = this.$refs.addGnbTask.validateOfAddGnbTaskDialog();
      if (!ruleDatas) {
        return;
      }
      let alias = this.$refs.addGnbTask.alias;
      let periodicUploadTime = this.$refs.addGnbTask.periodicUploadTime;
      let neClickInfo = this.$refs.addGnbTask.neClickInfo;
      if(neClickInfo == null || neClickInfo == undefined){
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.pleaseSelectNe') });
        return;
      }

      this.$loading.showLoadding(this.$t('System.loading'));
      await this.$axios.post('/lte/ems/pm/gnb/addGnbPmTask.html', {
        alias: alias,
        url: '',
        username: '',
        password: '',
        periodicUploadInterval: '900',
        periodicUploadTime: DateUtil.getTr069DateString(periodicUploadTime),
        nodeIp: neClickInfo.attribute.neIp,
        nodePort: neClickInfo.attribute.nePort,
        cpeId: neClickInfo.attribute.neName,
        neId: neClickInfo.attribute.neId
      }).then(response => {
        if(response.data.errorCode != 0 && response.data.errorCode!= 'SUCCESS' && response.data.errorCode!= 'success') {
          EventBus.$emit('toast', { type: 'warning', content: response.data.errorString });
        }else{
          EventBus.$emit('toast', { type: 'success', content: `${this.$t('Pm.createPmTask')}${this.$t('Pm.success')}` });
        }
        this.$refs.pmTaskManagementListForGnb.getTaskListOfGnbPmTask();
      });
      this.$loading.hideLoadding();
      this.$refs.addGnbTaskDialog.close();
    },

    async setTaskCommit(status){
      const data = this.$refs.pmTaskManagementListForGnb.rowDataOfPmGnbTaskList;
      if (data == null || data == '') {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectDataPlease') });
        return;
      }

      this.$loading.showLoadding(this.$t('System.loading'));
      await this.$axios.post('/lte/ems/pm/gnb/setGnbPmTask.html', {
        enable: status,
        alias: data.alias,
        url: '',
        username: '',
        password: '',
        periodicUploadInterval: data.reportCycle.toString(),
        PeriodicUploadTime: "",
        nodeIp: data.neIp,
        nodePort: data.nePort,
        cpeId: data.neName,
        neId: data.neId,
        instanceNumber: data.instanceNumber
      }).then(response => {
        if(response.data.errorCode != 0 && response.data.errorCode!= 'SUCCESS' && response.data.errorCode!= 'success') {
          EventBus.$emit('toast', { type: 'warning', content: response.data.errorString });
        }else{
          EventBus.$emit('toast', { type: 'success', content: `${this.$t('Pm.statusSetting')}${this.$t('Pm.success')}` });
        }
        this.$refs.pmTaskManagementListForGnb.getTaskListOfGnbPmTask();
      });
      this.$loading.hideLoadding();
    },



    async uploadGnbTaskCommit() {

      const ruleDatas = this.$refs.uploadGnbTask.validateOfReUploadDialog();
      if (!ruleDatas) {
        return;
      }
      let reUploadFileStartTimeData = this.$refs.uploadGnbTask.reUploadFileStartTime;
      this.$loading.showLoadding(this.$t('System.loading'));
      await this.$axios.post('/lte/ems/pm/gnb/uploadGnbPmTask.html', {
        url: '',
        username: '',
        password: '',
        reUploadFileStartTime: DateUtil.getTr069DateString(reUploadFileStartTimeData),
        nodeIp: this.gnbUploadGridClickData.neIp,
        nodePort: this.gnbUploadGridClickData.nePort,
        cpeId: this.gnbUploadGridClickData.neName,
        neName: this.gnbUploadGridClickData.neName,
        neId: this.gnbUploadGridClickData.neId,
        instanceNumber: this.gnbUploadGridClickData.instanceNumber
      }).then(response => {
        if(response.data.errorCode != 0 && response.data.errorCode!= 'SUCCESS' && response.data.errorCode!= 'success') {
          EventBus.$emit('toast', { type: 'warning', content: response.data.errorString });
        }else{
          EventBus.$emit('toast', { type: 'success', content: `${this.$t('Pm.uploadTask')}${this.$t('Pm.success')}` });
        }
        this.$refs.pmTaskManagementListForGnb.getTaskListOfGnbPmTask();
      });
      this.$loading.hideLoadding();
      this.$refs.uploadGnbTaskDialog.close();
    },


    closeAddGnbTaskDialog(){
      this.$refs.addGnbTaskDialog.close();
    },

    closeUploadGnbTaskDialog(){
      this.$refs.uploadGnbTaskDialog.close();
    },

    async deleteTaskCommit(){
      const data = this.$refs.pmTaskManagementListForGnb.rowDataOfPmGnbTaskList;
      if (data == null || data == '') {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectDataPlease') });
        return;
      }

      this.$loading.showLoadding(this.$t('System.loading'));

      await this.$axios.post('/lte/ems/pm/gnb/delGnbPmTask.html', {
        instanceNumber: data.instanceNumber,
        neId: data.neId,
        nodeIp: data.neIp,
        nodePort: data.nePort,
        cpeId: data.neName
      }).then(response => {
        if(response.data.errorCode != 0 && response.data.errorCode!= 'SUCCESS' && response.data.errorCode!= 'success') {
          EventBus.$emit('toast', { type: 'warning', content: response.data.errorString });
        }else{
          EventBus.$emit('toast', { type: 'success', content: `${this.$t('Pm.deleteTask')}${this.$t('Pm.success')}` });
        }
        this.$refs.pmTaskManagementListForGnb.getTaskListOfGnbPmTask();
      });

      this.$loading.hideLoadding();
    }
  },
};
</script>

<style>

</style>
